import React from 'react';
import './HowPartnershipWorks.css'; // We will be updating this file

import {
  FaUserCheck,
  FaChartLine,
  FaPrayingHands,
} from 'react-icons/fa';

const partnershipSteps = [
    {
        step: '1',
        title: 'Customize & Onboard',
        color: '#B25F30',
        desc: [
            'Share your community’s dietary and ritual needs.',
            'Work with Vanidya to co-create a tailored product catalog.',
            'Complete onboarding and set preferences for group orders and delivery.',
        ],
        icon: <FaUserCheck />,
    },
    {
        step: '2',
        title: 'Order & Organize',
        color: '#DF8D44',
        desc: [
            'Place group or event orders easily through a dedicated dashboard.',
            'Track deliveries and coordinate logistics for festivals or regular needs.',
            'Benefit from support for special occasions and custom requests.',
        ],
        icon: <FaChartLine />,
    },
    {
        step: '3',
        title: 'Nourish & Celebrate',
        color: '#E59E28',
        desc: [
            'Ensure every member has access to Satvik, organic, and ritual essentials.',
            'Strengthen your community’s well-being with the right products, on time.',
            'Review insights and feedback to improve future collaborations.',
        ],
        icon: <FaPrayingHands />,
    },
];

const HowPartnershipWorks = () => {
  return (
    <section
      id="how-it-works-temples"
      className="page-section how-partnership-works-section"
    >
      <h2 id="how-partnership-works-title" className="_hTitle_s5E_ workflow-title">How the Partnership Works</h2>
      <p className=" workflow-subtitle _hSubtitle_t6F_ ">
        A simple, transparent journey in three steps.
      </p>

      <ol className="comic-cards-container" aria-labelledby="how-partnership-works-title" role="list">
        {partnershipSteps.map((step) => (
          <li
            key={step.step}
            className="card-wrapper"
            style={{ '--card-color': step.color }}
            role="listitem"
          >
            <div
              className="comic-card"
              tabIndex={0}
              role="group"
              aria-label={`Step ${step.step}: ${step.title}`}
              title={`${step.title}`}
            >
              <div className="card-header">
                <span className="step-number">{`STEP ${step.step}`}</span>
                <div className="card-icon_" aria-hidden="true">{step.icon}</div>
              </div>
              <div className="card-body">
                <h3 className="card-title__">{step.title}</h3>
                <ul className="card-desc">
                  {step.desc.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default HowPartnershipWorks;